export const classes = (...args) => args.join(' ')
